module.exports = __webpack_public_path__ + "img/banner6.a1c5fe42.png";